import { mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-616ea49c")

_pushScopeId("data-v-616ea49c")
const _hoisted_1 = {
  class: "wrapper",
  ref: "wrapper"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "markered-background",
    style: _ctx.containerSize
  }, [
    _createVNode("canvas", _mergeProps({
      class: "canvas",
      ref: "canvasElement"
    }, _ctx.canvasSize), null, 16),
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512)
  ], 4))
})